import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "lhpe-textarea",
  templateUrl: "./text-area.component.html",
  styleUrls: ["./text-area.component.scss"],
})
export class TextAreaComponent implements OnInit {
  @Input() formGroup?: FormGroup;
  @Input() placeholder?: string;
  @Input() controlName?: string | number | null;
  @Input() control?: FormControl;
  @Input() rows!: number;
  @Input() required?: boolean;
  @Input() disabled: boolean = false;
  @Input() maxlength?: number;
  @Input() hint?: string;

  formControl!: FormControl;

  constructor() {}

  ngOnInit(): void {
    if (!this.rows) {
      this.rows = 4;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formGroup) {
      this.formControl! = this.formGroup!.get(
        this.controlName as string,
      )! as FormControl;
    } else if (changes.control) {
      this.formControl = this.control!;
    }
  }

  getErrorMessage(formControl: AbstractControl | undefined) {
    if (formControl) {
    }
    return "";
  }
}
